import type { FaireProductEntity } from "../../entity_types/product";

export const p_8d525ha9gf: FaireProductEntity = {
  token: "p_8d525ha9gf",
  type: "product",
  name: "NASAL RINSE SPRAY | 1 oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/3ff10d4c4ce8d4e4598ceba8df8c05ebd2bb1580c56b919ad415ed700df259d6.png",
  galleryImageUrls: [],
  priceDollars: 12.6,
  description:
    "\nA must have for those pesky allergies. This refreshing nasal spray helps to reduce inflammation while combating bacterial and viral invaders and can also be used as a daily preventative!\nFor more product information or questions on products, please join our VIP group on Facebook. ",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:43.757Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
